import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const wrike = defineConnector({
  identifier: "wrike",
  name: "Wrike",
  tagLine: "Project and work management platform",
  keywords: "tasks folders projects work management collaboration",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://www\\.wrike\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an access token",
      items: [
        {
          kind: "markdown",
          content:
            "In [Wrike](https://www.wrike.com/), go to **Apps & Integrations → API** and create a permanent access token.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://www.wrike.com/api/v4/contacts",
  },
});
